import axios from '@axios'

export const state = {
  reports: {},
  exports: [],
}

export const getters = {
  allReports: (state) => state.reports,
  allExports: (state) => state.exports,
}

export const mutations = {
  GET_REPORTS: (state, data) => {
    if (!data) {
      state.reports = {}
      return false
    }
    state.reports = data
  },
  GET_EXPORTS: (state, data) => {
    if (!data) {
      state.exports = []
      return false
    }
    state.exports = data.reports
  },
  DELETE_REPORT: (state, report) => {
    state.exports = state.exports.filter((exp) => exp.id !== report.id)
  },
}

export const actions = {
  async getReports({ commit, dispatch }, { paginate }) {
    dispatch('layout/changeLoading', true, { root: true })
    await axios
      .get('/sms/reports/usage', { params: paginate })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_REPORTS', resp.data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_REPORTS', null)
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async exportReport({ commit }, { params }) {
    return axios.get('/sms/reports/usage/export', { params: params })
  },

  async getExports({ commit }) {
    await axios
      .get('/sms/reports/usage/exports')
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_EXPORTS', resp.data)
        } else {
          commit('GET_EXPORTS', null)
        }
      })
      .catch(() => {
        commit('GET_EXPORTS', null)
      })
  },

  async deleteExport({ commit, dispatch }, report) {
    await axios
      .delete(`/users/profile/upload-document/${report.id}`)
      .then((resp) => {

        if (resp.status === 204) {
          commit('DELETE_REPORT', report)
        }
      })
  },
}
